import { render } from "./ArticleFeature.vue?vue&type=template&id=30828ffe&scoped=true"
import script from "./ArticleFeature.vue?vue&type=script&lang=js"
export * from "./ArticleFeature.vue?vue&type=script&lang=js"

import "./ArticleFeature.vue?vue&type=style&index=0&id=30828ffe&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30828ffe"]])

export default __exports__